import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { StyledExpandableSectionListItem } from 'components/Shared/style';

const Item = ({ rooms, _current, id, index, children }) => {
    const isActiveClassName = useMemo(() => {
        if (id === _current) {
            return 'active';
        }

        const foundRoom = rooms.find(({ id: roomId, _feed }) => roomId === id && _feed === _current);

        return foundRoom ? 'active' : '';
    }, [rooms, _current, id]);

    return (
        <StyledExpandableSectionListItem
            key={id}
            className={isActiveClassName}
        >
            {children(id, index)}
        </StyledExpandableSectionListItem>
    );
}

const ClickableList = ({ items, _current = '', children = null, rooms = [] }) =>
    items.map((id, index) => id ? (
        <Item
            key={id}
            id={id}
            index={index}
            _current={_current}
            rooms={rooms}
        >
            {children}
        </Item>
    ) : null);

ClickableList.propTypes = {
    items: PropTypes.arrayOf(PropTypes.string).isRequired,
    _current: PropTypes.string,
    rooms: PropTypes.arrayOf(PropTypes.object),
    children: PropTypes.any
};

export default ClickableList;
